export const percentRenderer = (value) => {
          if(value =='Infinity'){ 
            return `NA %`
          }else{
          return `${parseFloat(value || 0).toFixed(2)} %`
        }
};